// extracted by mini-css-extract-plugin
module.exports = {"editor":"index_editor_32Yky"};